import { Column, Entity } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_sm2_migrations')
export class Sm2MigrationsEntity extends BaseEntity {
	@Column('bigint', { name: 'timestamp' })
	public timestamp!: string;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;
}
